export const environment = {
    BASE_URL: 'https://eu.satsang.org.in',
    // BASE_URL: 'http://localhost:6060',
    SSO_URL: 'https://sso.test.satsang.org.in/',
    // localhostUrl: 'http://localhost:4200/login',  // [USE IT FOR DEVELOPMENT BUT NEVER PUSH]
    localhostUrl: 'https://eu.satsang.org.in/login',  // [USE IT FOR DEVELOPMENT BUT NEVER PUSH]
    // localhostUrl: '',
    orgUrl: 'https://www.test.satsang.org.in',
    accoUrl: 'https://dev.acco.satsang.org.in',
    activityLogoutTimeInMins: 60,
    production: false,
    stripe_publisher_key: 'pk_test_51Q1trI2Mb5kwBTVTvOZ11uk9pOFaQehfpMTKWodEH6SZBVGPZpPjPkvC2Tkp41KsYbrmTttuR3MzrFIGT3xClXxP00t7Qu62WR',
    IST_FORM: ['APRNM', 'DPRNM'],
    MISC_CODE_TYPE: ['MANDIR', 'MISC']
};
